import React from "react";

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function PostCountIcon(props: any) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      fill={props?.fill}
      viewBox="0 0 24 24"
    >
      <path d="M4 19h16v2H4a2 2 0 01-2-2V5a2 2 0 012-2h7.17L19 7.83V19zm2-2h12V9H13V3H6v14zm8-12.17L17.17 7H14V5.83zM7 11h4v2H7v-2zm0 4h8v2H7v-2z" />
    </svg>
  );
}

export default PostCountIcon;
